module.exports = __webpack_public_path__ + "img/5.a0b69e4b.png";